import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Controller, useFormContext } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

interface InputTextProps {
    name: string;
    placeholder?: string;
    styles?: React.CSSProperties;
}

const StyledFormControl = styled(FormControl)<{ styles?: React.CSSProperties }>(({ theme, styles }) => ({
    '& .label': {
        marginBottom: '8px',
        color: theme.palette.secondary.main,

        '& .required': {
            color: theme.palette.error.main,
        },

        '&.Mui-focused': {
            color: theme.palette.secondary.main,
        },
    },
    ...styles,
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-root': {
        borderRadius: '8px',
        padding: '0px',
        border: `1px solid ${theme.palette?.primaryWhitePurple.main || '#FAF6FD'}`,
    },
    '& .MuiInputBase-input': {
        padding: '14px 16px',
        color: theme.palette.secondary.main,
    },
}));

const InputText: React.FC<InputTextProps> = ({ name, placeholder = '', styles }) => {
    const { control } = useFormContext();

    return (
        <StyledFormControl styles={styles}>
            <Controller
                name={name}
                control={control}
                render={({ field, fieldState: { error } }) => (
                    <StyledTextField
                        {...field}
                        variant="outlined"
                        fullWidth
                        placeholder={placeholder}
                        error={!!error}
                        InputLabelProps={{ shrink: false }}
                        value={field.value || ''}
                        onChange={e => field.onChange(e.target.value)}
                        sx={{
                            '& .MuiInputBase-root.Mui-error .MuiInputBase-input::placeholder': {
                                color: theme => theme.palette.errorRed.main,
                                opacity: 1,
                            },
                        }}
                    />
                )}
            />
        </StyledFormControl>
    );
};

export default InputText;
